const Vui = () => {
  return (
    <div className='flex items-center justify-center pb-5'>
      <div className='tracking-normal text-xl sm:text-4xl md:text-4xl lg:text-6xl xl:text-7xl 2xl:text-7xl'>
        <h1 className='text-slate-50 pt-5 pb-2 flex items-center justify-center font-bold text-4xl sm:text-7xl sm:pb-5 md:text-7xl lg:text-8xl xl:text-9xl 2xl:text-9xl'>Lúc Thú Vui Này</h1>
        <p className='text-slate-300 pt-5 leading-tight'>
          Lúc thú vui này<br />
          lòng còn quyến luyến<br />
          anh em chúng mình
        </p>
        <p className='text-pink-300 pt-5 leading-tight'>
          Lúc thú vui này<br />
          lòng mình những muốn<br />
          anh em thấu tình
        </p>
        <p className='text-slate-300 pt-5 leading-tight'>
          Rời tay nhau nhớ lâu nhé.<br />
          Tình anh em chớ quên nhé
        </p>
        <p className='text-pink-300 pt-5 leading-tight'>
          Lòng anh em nhớ nhau<br />
          tuy xa mà hóa ra gần.
        </p>
        <br />
        <p className='text-slate-300 pt-5 leading-tight'>
          Quyến luyến nhau là<br />
          tình mình đến với anh em ở gần
        </p>
        <p className='text-pink-300 pt-5 leading-tight'>
          Quyến luyến nhau là<br />
          tình mình đối với anh em các Đoàn
        </p>
        <p className='text-slate-300 pt-5 leading-tight'>
          Rời tay nhau nhớ lâu nhé.<br />
          Tình anh em chớ quên nhé
        </p>
        <p className='text-pink-300 pt-5 leading-tight'>
          Lòng anh em nhớ nhau<br />
          tuy xa mà hóa ra gần.
        </p>
      </div>
    </div>
  )
}

export default Vui
